import { render, staticRenderFns } from "./LinkPane.vue?vue&type=template&id=7af99436&scoped=true"
import script from "./LinkPane.vue?vue&type=script&lang=ts"
export * from "./LinkPane.vue?vue&type=script&lang=ts"
import style0 from "./LinkPane.vue?vue&type=style&index=0&id=7af99436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af99436",
  null
  
)

export default component.exports